import { render, staticRenderFns } from "./ModalReemplazarDocumentosExistentes.vue?vue&type=template&id=b9736c54&scoped=true&"
import script from "./ModalReemplazarDocumentosExistentes.vue?vue&type=script&lang=js&"
export * from "./ModalReemplazarDocumentosExistentes.vue?vue&type=script&lang=js&"
import style0 from "./ModalReemplazarDocumentosExistentes.vue?vue&type=style&index=0&id=b9736c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9736c54",
  null
  
)

export default component.exports